import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { authApi } from '../../api/authApi'
import { useAppDispatch } from '../../store'
import { setTokens, setUser } from '../../store/slices/authSlice'
import toast from 'react-hot-toast'

export default function VerifyOtpPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useAppDispatch()
  const email = (location.state as { email?: string })?.email ?? ''

  const [otp, setOtp] = useState('')
  const [loading, setLoading] = useState(false)
  const [resending, setResending] = useState(false)

  const handleVerify = async () => {
    if (otp.length !== 6) { toast.error('Enter the 6-digit OTP'); return }
    setLoading(true)
    try {
      const response = await authApi.verifyOtp({ email, otp })
      const data = response.data.data
      dispatch(setTokens({ accessToken: data.accessToken, refreshToken: data.refreshToken }))
      dispatch(setUser(data.user))
      toast.success('Email verified!')
      navigate('/')
    } catch (err: unknown) {
      const error = err as { response?: { data?: { message?: string } } }
      toast.error(error.response?.data?.message ?? 'Invalid OTP')
    } finally {
      setLoading(false)
    }
  }

  const handleResend = async () => {
    setResending(true)
    try {
      await authApi.resendOtp(email)
      toast.success('OTP resent to ' + email)
    } catch {
      toast.error('Failed to resend OTP')
    } finally {
      setResending(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="card w-full max-w-sm text-center">
        <h2 className="text-xl font-bold text-gray-900 mb-2">Verify Your Email</h2>
        <p className="text-sm text-gray-500 mb-6">
          We sent a 6-digit OTP to <strong>{email}</strong>
        </p>
        <input
          type="text"
          maxLength={6}
          className="input text-center text-2xl tracking-widest font-mono"
          value={otp}
          onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
          placeholder="000000"
        />
        <button onClick={handleVerify} disabled={loading} className="btn-primary w-full justify-center mt-4">
          {loading ? 'Verifying...' : 'Verify OTP'}
        </button>
        <button onClick={handleResend} disabled={resending} className="text-sm text-primary-600 mt-3 hover:underline">
          {resending ? 'Sending...' : 'Resend OTP'}
        </button>
      </div>
    </div>
  )
}
